import React from 'react';
import { Typography, Link, TypographyProps, LinkProps } from '@mui/material';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import { useHasPermission } from 'hooks/authorization.hooks';
import { useGlobalDrawer } from 'components/drawers/global-drawer/global-drawer.hooks';

interface CustomerLinkProps {
  customerName: string;
  customerId?: string | null;
  TypographyProps?: TypographyProps;
  LinkProps?: LinkProps;
}

const CustomerLink: React.FC<CustomerLinkProps> = ({
  customerName,
  customerId = null,
  TypographyProps,
  LinkProps,
}) => {
  const hasViewCustomerPermission = useHasPermission('VIEW_CUSTOMER');
  const { open } = useGlobalDrawer('globalCustomerQuickDetailsDrawer');

  if (!customerName) return null;

  const canLink = customerId && hasViewCustomerPermission;

  if (canLink)
    return (
      <Link
        onClick={e => {
          e.stopPropagation();
          open({ customerId });
        }}
        sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
        {...LinkProps}
        data-testid="CustomerLink.Link"
      >
        <PersonOutlineIcon fontSize="small" />{' '}
        <Typography sx={{ marginLeft: 1 }} {...TypographyProps}>
          {customerName}
        </Typography>
      </Link>
    );

  return (
    <Typography data-testid="CustomerLink.Span" {...TypographyProps}>
      {customerName}
    </Typography>
  );
};

export default CustomerLink;
